import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { PageHeader, Result, Button, Spin } from 'antd';
import { MyBreadcrumb, accessControls } from 'utils';
import ScheduleForm from './form';

export default function ScheduleCreate() {
  const history = useHistory();
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    accessControls
      .fetch()
      .then(setPermissions)
      .catch(() => setPermissions({}));
  }, []);

  if (permissions == null) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!accessControls.can(permissions, 'Scheduling.update:any')) {
    return (
      <div style={{ padding: 24 }}>
        <Result
          status="403"
          title="Access denied"
          subTitle="You do not have permission to create schedules."
          extra={
            <Button type="primary" onClick={() => history.push('/')}>
              Go to Dashboard
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Time Tracker', path: '/time-tracker/tracker' },
          { label: 'Schedules', path: '/time-tracker/scheduling' },
          { label: 'Create', path: '' },
        ]}
      />
      <PageHeader
        ghost={false}
        onBack={() => history.push('/time-tracker/scheduling')}
        title="Create Schedule"
        subTitle="Add a weekly roster with timezone and group access"
      >
        <ScheduleForm />
      </PageHeader>
    </div>
  );
}
